export default __webpack_public_path__ + "static/media/Wales.443c333f.png";